// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1vwov","background":"Modal_background__3v5bl","content":"Modal_content__BZbGL","controls":"Modal_controls__YHz0i"};